module.exports = __webpack_public_path__ + "img/person.3b20226d.jpg";